import { AUTH_THEME_TOKENS } from './authTheme';

/** Fondo sólido del documento para que el “rebote” de scroll no muestre un color distinto al shell. */
export const ADMIN_SHELL_DOCUMENT_BG = '#08111f';
export const AUTH_LIGHT_DOCUMENT_BG = AUTH_THEME_TOKENS.light.documentBg;
export const AUTH_DARK_DOCUMENT_BG = AUTH_THEME_TOKENS.dark.documentBg;
export const AUTH_DEFAULT_DOCUMENT_BG = AUTH_DARK_DOCUMENT_BG;

export type DocumentOverscrollColorMode = 'light' | 'dark';

export function resolveDocumentOverscrollBackground(
  pathname: string,
  opts: {
    publicLight: string;
    publicDark: string;
    colorMode: DocumentOverscrollColorMode;
  }
): string {
  const p = pathname.startsWith('/') ? pathname : `/${pathname}`;
  if (
    p.startsWith('/admin') ||
    p.startsWith('/rtl') ||
    p.startsWith('/pages') ||
    p.startsWith('/objects') ||
    p.startsWith('/tools')
  ) {
    return ADMIN_SHELL_DOCUMENT_BG;
  }
  if (
    p.startsWith('/public') ||
    p.startsWith('/event/') ||
    p.startsWith('/e/') ||
    p.startsWith('/competition/') ||
    p.startsWith('/c/') ||
    p.startsWith('/r/') ||
    p.startsWith('/club/') ||
    p.startsWith('/ticket/') ||
    p.startsWith('/profile/') ||
    p.startsWith('/p/')
  ) {
    return opts.colorMode === 'dark' ? opts.publicDark : opts.publicLight;
  }
  return opts.colorMode === 'dark'
    ? AUTH_DARK_DOCUMENT_BG
    : AUTH_LIGHT_DOCUMENT_BG;
}

export function applyDocumentOverscrollBackground(background: string): void {
  document.documentElement.style.setProperty('--orgcloud-document-bg', background);
  document.documentElement.style.background = background;
  document.body.style.background = background;
  document.documentElement.style.overscrollBehaviorY = 'none';
  document.body.style.overscrollBehaviorY = 'none';
  document.documentElement.style.overflowX = 'hidden';
  document.body.style.overflowX = 'hidden';
  const root = document.getElementById('root');
  if (root) {
    root.style.background = background;
    root.style.overscrollBehavior = 'none';
    root.style.overflowX = 'hidden';
  }
}
